import React from "react";
import ReactDOM from "react-dom";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import Router from "./Router";

import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { CatalogProvider } from "./contexts/CatalogContext";

import "./firebase/firebase";

import "./i18n";
import "./reset.css";

// Initialize dayjs locale for Portuguese (Brazil)
dayjs.locale("pt-br");

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });

  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

ReactDOM.render(
  <AuthProvider>
    <NotificationProvider>
      <CatalogProvider>
        <Router />
      </CatalogProvider>
    </NotificationProvider>
  </AuthProvider>,
  document.getElementById("root")
);
